import { Feedback, PeopleIcon, Rating } from './icons'

const AiFurnance = () => {
  return (
    <div
      className="flex flex-col gap-16 max-w-7xl items-center justify-center mx-auto mt-10 px-6 xl:px-8 w-full"
      id="team-mission"
    >
      <div className="flex flex-col w-full">
        <h1 className="xl:w-[768px] text-[#155EEF] text-base font-semibold leading-normal">
          Incubate Better
        </h1>
        <h2 className="xl:w-[768px] text-[#FFFFFF] text-[36px] font-semibold mt-3 leading-[44px]">
          Our Process{' '}
        </h2>
        <p className="mt-5 xl:w-[768px] text-[#D0D5DD] text-xl font-normal  leading-[30px]">
          The AI Furnace is our expert panel, selecting the most promising
          applications.
        </p>
      </div>
      <div className="xl:w-[1280px] xl:h-[500px] px-6 justify-start items-center gap-16 flex flex-col xl:flex-row">
        <div className="flex flex-col gap-12  w-full h-full">
          <div className="flex flex-col items-start xl:w-[576px] xl:h-[178px] justify-start gap-5 mb-3 sm:mb-0 ">
            {/* icon */}
            <PeopleIcon />
            <div className="flex flex-col gap-2">
              <h1 className="xl:w-[576px] text-[#FFFFFF] text-xl font-semibold  leading-[30px]">
                Expert Judgement Panel
              </h1>
              <p className="xl:w-[576px] text-[#98A2B3] text-base font-normal  leading-normal">
                Our AI Incubator Panel comprises 30+ experts from fields like
                technology, entrepreneurship, and venture capital. This diverse
                team promises a thorough, balanced evaluation of every startup.
              </p>
            </div>
          </div>
          <div className="flex gap-8 flex-col xl:flex-row">
            <div className="xl:w-[272px] xl:h-[274px] flex-col justify-start items-start gap-5 inline-flex mb-3 sm:mb-0">
              <Rating />
              <div className="flex flex-col gap-2">
                <h1 className="xl:w-[272px] text-white text-xl font-semibold  leading-[30px]">
                  Combined Rating System
                </h1>
                <p className="xl:w-[272px] text-[#98A2B3] text-base font-normal leading-normal">{`Our rating system captures our panel's collective insight. Startups are assessed on technological innovation, market viability, and team capability. Every judge's input shapes the final score, ensuring we select truly standout startups.`}</p>
              </div>
            </div>
            <div className="xl:w-[272px] xl:h-[274px] flex-col justify-start items-start gap-5 inline-flex mb-3 sm:mb-0 ">
              <Feedback />
              <div className="flex flex-col gap-2">
                <h1 className="xl:w-[272px] text-white text-xl font-semibold  leading-[30px]">
                  Constructive Feedback
                </h1>
                <p className="xl:w-[272px] text-[#98A2B3] text-base font-normal leading-normal">{`Central to our approach is constructive feedback. Every interaction is a learning opportunity. All startups get in-depth feedback from experts, gaining insights and advice irrespective of the final decision.`}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col xl:flex-row gap-6 md:max-w-[576px] ">
          <div className="flex flex-col gap-6 xl:w-[276px] ">
            <img
              className="bg-white rounded-xl border h-full border-[#D6D6D6] object-cover xl:h-[306px] mb-3 sm:mb-0"
              width={1000}
              height={1000}
              alt="image"
              src="/images/home/f-2.webp"
            />
            <img
              className=" bg-white rounded-xl border  border-[#D6D6D6]  object-cover xl:h-[170px] mb-3 sm:mb-0"
              height={1000}
              width={1000}
              alt="image"
              src="/furnanceApply/ImagesApply/1.webp"
            />
          </div>
          <div className="flex flex-col gap-6 xl:w-[276px] ">
            <img
              className="bg-white rounded-xl border  h-1/2 border-[#D6D6D6]  object-cover xl:h-[238px] mb-3 sm:mb-0"
              height={1000}
              width={1000}
              alt="image"
              src="/furnanceApply/ImagesApply/4.webp"
            />
            <img
              className="bg-white rounded-xl border  h-1/2 border-[#D6D6D6]  object-cover xl:h-[238px] mb-3 sm:mb-0"
              height={1000}
              width={1000}
              alt="image"
              src="/images/home/f-4.webp"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AiFurnance
